export default __webpack_public_path__ + "static/media/xls.bc4faecd.svg";